<template>
    <v-app>
        <v-layout wrap>
            <v-flex>
                <!--  SECTION - INPUTS FILTERS -->
                <v-card class="grey lighten-5 pr-6 pl-6" outlined>
                    <v-card-title class="transparent">
                        Gestão de Demandas
                    </v-card-title>
                    <v-card-actions
                        class="d-flex flex-column align-end  pr-2 pl-2 pt-7"
                    >
                        <!-- ANCHOR - FORM INPUTS -->
                        <v-form ref="form">
                            <v-row>
                                <TreeTextField
                                    class="pr-4 pl-4"
                                    :ActionButton="handleModalTree"
                                    :fields="tree"
                                    :cols="3"
                                />

                                <TextField
                                    class="pr-4 pl-4"
                                    :cols="3"
                                    :fields="product"
                                />

                                <SelectField
                                    class="pr-4 pl-4"
                                    :cols="3"
                                    :fields="curve"
                                />

                                <TextField
                                    class="pr-4 pl-4"
                                    :cols="3"
                                    :fields="branch"
                                />

                                <SelectField
                                    class="pr-4 pl-4"
                                    :cols="3"
                                    :fields="type_branch"
                                />

                                <SelectField
                                    class="pr-4 pl-4"
                                    :cols="3"
                                    :fields="task_status"
                                />

                                <TimeField
                                    color="#0077c8"
                                    class="pr-4 pl-4"
                                    placeholder="00/00/0000"
                                    :cols="3"
                                    outerLabel="Data de Inicio"
                                    v-bind:dateProps="start_date"
                                    @input="startDate"
                                />

                                <TimeField
                                    color="#0077c8"
                                    class="pr-4 pl-4"
                                    placeholder="00/00/0000"
                                    :cols="3"
                                    outerLabel="Data do fim"
                                    v-bind:dateProps="end_date"
                                    @input="endDate"
                                    :errormsg="error"
                                />
                            </v-row>
                        </v-form>
                        <!-- ANCHOR - Buttons -->
                        <div class="d-flex mt-5 pb-4">
                            <Button
                                type="secondary"
                                class="mr-4"
                                label="Limpar"
                                v-on:click.native="handleReset()"
                            />
                            <Button
                                label="Pesquisar"
                                v-on:click.native="handleSearch()"
                            />
                        </div>
                    </v-card-actions>
                </v-card>

                <!--  SECTION - TABLE AND ACTION BUTTONS -->
                <v-card class=" pr-6 pl-6" flat>
                    <!-- NOTE - Action Buttons on top of table -->
                    <md-card-actions md-alignment="space-between">
                        <div class="md-toolbar-section-start">
                            <h1 class="md-title">Demandas</h1>
                        </div>

                        <IButton
                            icon="mdi-pencil-outline"
                            tip="Editar"
                            color="primary"
                            v-if="
                                this.selectedItems.length > 0 &&
                                    this.editing.demand_id === 0
                            "
                            @ActionButton="EditModal"
                        />

                        <IButton
                            icon="mdi-clock-outline"
                            tip="Sleep mode"
                            color="#3F51B5"
                            @ActionButton="OpenSleepModal"
                            v-if="
                                this.selectedItems.length > 0 &&
                                    this.editing.demand_id === 0
                            "
                        />

                        <Button
                            v-on:click.native="handleCancelEditing()"
                            label="Cancelar"
                            type="secondary"
                            class="mr-3"
                            v-if="this.editing.demand_id !== 0"
                        />
                        <Button
                            label="Salvar"
                            v-on:click.native="handleSaveEditing()"
                            v-if="this.editing.demand_id !== 0"
                        />
                    </md-card-actions>
                    <div v-if="!filterLoading">
                        <md-card-content>
                            <md-table
                                :value="demandsListPage.results"
                                :md-sort.sync="currentSort"
                                :md-sort-order.sync="currentSortOrder"
                                :md-sort-fn="customSort"
                                @md-selected="onSelectDemand"
                                class="paginated-table table-striped table-hover"
                            >
                                <md-table-row
                                    slot="md-table-row"
                                    slot-scope="{ item }"
                                    md-selectable="multiple"
                                    md-auto-select
                                >
                                    <md-table-cell
                                        v-for="column in visibleColumns"
                                        :md-label="columnNames[column]"
                                        :md-sort-by="column"
                                        :key="column"
                                        :title="item[column]"
                                    >
                                    
                                        <!-- current week -->
                                        <div
                                            v-if="
                                                (column == 'current_week' &&
                                                    editing.demand_id === 0) ||
                                                    (column == 'current_week' &&
                                                        editing.demand_id !==
                                                            item.id)
                                            "
                                            @dblclick="
                                                handleEditFieldTable(item)
                                            "
                                        >
                                            {{
                                                item['demands'][0].interval ==
                                                'current_week'
                                                    ? item['demands'][0]
                                                          .quantity
                                                    : item['demands'][1]
                                                          .interval ==
                                                      'current_week'
                                                    ? item['demands'][1]
                                                          .quantity
                                                    : item['demands'][2]
                                                          .quantity
                                            }}
                                        </div>
                                        <div
                                            v-else-if="
                                                column == 'current_week' &&
                                                    editing.demand_id ===
                                                        item.id
                                            "
                                        >
                                            <v-text-field
                                                outlined
                                                dense
                                                v-model="editing.current_week"
                                            />
                                        </div>

                                        <!-- first week -->
                                        <div
                                            v-if="
                                                (column == 'first_week' &&
                                                    editing.demand_id === 0) ||
                                                    (column == 'first_week' &&
                                                        editing.demand_id !==
                                                            item.id)
                                            "
                                            @dblclick="
                                                handleEditFieldTable(item)
                                            "
                                        >
                                            {{
                                                item['demands'][0].interval ==
                                                'first_week'
                                                    ? item['demands'][0]
                                                          .quantity
                                                    : item['demands'][1]
                                                          .interval ==
                                                      'first_week'
                                                    ? item['demands'][1]
                                                          .quantity
                                                    : item['demands'][2]
                                                          .quantity
                                            }}
                                        </div>
                                        <div
                                            v-else-if="
                                                column == 'first_week' &&
                                                    editing.demand_id ===
                                                        item.id
                                            "
                                        >
                                            <v-text-field
                                                outlined
                                                dense
                                                v-model="editing.first_week"
                                            />
                                        </div>

                                        <!-- second week -->
                                        <div
                                            v-if="
                                                (column == 'second_week' &&
                                                    editing.demand_id === 0) ||
                                                    (column == 'second_week' &&
                                                        editing.demand_id !==
                                                            item.id)
                                            "
                                            @dblclick="
                                                handleEditFieldTable(item)
                                            "
                                        >
                                            {{
                                                item['demands'][0].interval ==
                                                'second_week'
                                                    ? item['demands'][0]
                                                          .quantity
                                                    : item['demands'][1]
                                                          .interval ==
                                                      'second_week'
                                                    ? item['demands'][1]
                                                          .quantity
                                                    : item['demands'][2]
                                                          .quantity
                                            }}
                                        </div>
                                        <div
                                            v-else-if="
                                                column == 'second_week' &&
                                                    editing.demand_id ===
                                                        item.id
                                            "
                                        >
                                            <v-text-field
                                                outlined
                                                dense
                                                v-model="editing.second_week"
                                            />
                                        </div>

                                        <div v-else>
                                            {{
                                                column == 'product_id'
                                                    ? item['product']
                                                          .external_id
                                                    : column == 'product_name'
                                                    ? item['product'].name
                                                    : column ==
                                                      'product_reference'
                                                    ? item['product']
                                                          .reference_number
                                                    : column == 'branch'
                                                    ? `${item['branch'].id} - ${item['branch'].name}`
                                                    : column == 'curve'
                                                    ? item['curve']['curve']
                                                    : item[column]
                                            }}
                                        </div>
                                    </md-table-cell>
                                </md-table-row>
                            </md-table>
                        </md-card-content>

                        <md-card-actions md-alignment="space-between">
                            <div class="">
                                <p class="card-category">
                                    Mostrando
                                    {{ this.demandsListPage.results.length }}
                                    itens de um total de {{ total }}.
                                </p>
                            </div>
                            <pagination
                                class="pagination-no-border pagination-success"
                                v-model="pagination.currentPage"
                                :per-page="pagination.perPage"
                                :total="total"
                            >
                            </pagination>
                        </md-card-actions>
                    </div>
                    <div v-else>
                        <md-card-content>
                            <div class="text-center mt-2 pb-2 ">
                                <img
                                    src="loader.svg"
                                    style="width: 100px; height: 100px"
                                />
                            </div>
                        </md-card-content>
                    </div>
                </v-card>
            </v-flex>

            <ModalDemand
                :dialog="DemandaModal"
                @Cancel="resetModal"
                @Submit="submitDateNapDemand"
                :loading="loading"
                :ModalType="ModalType"
                :sleepItems="selectedItems"
            />

            <ModalTree :treeModal="treeModal" :ActionButton="handleModalTree" />
            <ModalEdit
                :dialog="Edit"
                :close="closeEdit"
                v-bind:product_id="
                    this.selectedItems[0] !== undefined
                        ? Number(this.selectedItems[0].product.id)
                        : 0
                "
                v-bind:branch_id="
                    this.selectedItems[0] !== undefined
                        ? Number(this.selectedItems[0].branch.id)
                        : 0
                "
                v-bind:demand_id="
                    this.selectedItems[0] !== undefined
                        ? Number(this.selectedItems[0].id)
                        : 0
                "
            />
        </v-layout>
    </v-app>
</template>

<script>
import { Pagination } from '@/components'

import TextField from '@/components/Inputs/TextField.vue'
import SelectField from '@/components/Inputs/SelectField.vue'
import TimeField from '@/components/Inputs/TimeField.vue'

import Button from '@/components/Button/Button'
import IButton from '@/components/Button/Icon'

import ModalDemand from '@/components/Modal/Modal-Demand'
import ModalTree from '../../components/Modal/Modal-Tree.vue'
import TreeTextField from '../../components/Inputs/TreeTextField.vue'
import ModalEdit from '@/components/Modal/Modal-DemandEdit'
import { mapState, mapActions } from 'vuex'
import { Demand as Model } from '@/models/demand.model'

export default {
    async created() {
        this.checkParams()

        await this.fetchDemands()
    },

    components: {
        TextField,
        Button,
        SelectField,
        TimeField,
        ModalEdit,
        IButton,
        ModalDemand,
        ModalTree,
        TreeTextField,
        Pagination
    },

    computed: {
        ...mapState({
            demandsListPage: state => state['demands'].listPage
        }),

        total() {
            return this.demandsListPage.count
        },

        visibleColumns() {
            let columns = []
            Object.keys(this.showColumns).forEach(key => {
                if (this.showColumns[key]) columns.push(key)
            })
            return columns
        }
    },

    data() {
        return {
            editDemandModal: false,
            treeModal: false,
            Edit: false,
            filterNodeName: 'Todos os itens',
            ModalType: '',
            loading: false,
            DemandaModal: false,
            start_date: null,
            end_date: null,
            error: '',
            product: {
                text: '',
                outerLabel: 'Produto'
            },
            tree: {
                label: '',
                text: 'Todos os itens',
                outerLabel: 'Árvore de sortimento'
            },
            node: null,
            branch: {
                text: '',
                outerLabel: 'Filial'
            },
            type_branch: {
                outerLabel: 'Tipo de Filial',
                answers: [
                    { label: 'Todos os tipos', value: null },
                    { label: 'Filial', value: 'S' },
                    { label: 'CD', value: 'D' }
                ],
                selected: null
            },
            erro: {
                text: '',
                outerLabel: '% Erro'
            },
            curve: {
                outerLabel: 'Curva',
                answers: [
                    { label: 'Todas as curvas', value: null },
                    { label: 'AA', value: 'AA' },
                    { label: 'A', value: 'A' },
                    { label: 'B', value: 'B' },
                    { label: 'C', value: 'C' },
                    { label: 'CC', value: 'CC' }
                ],
                selected: null
            },
            task_status: {
                outerLabel: 'Tarefas',
                placeholder: 'Tarefas Abertas',
                answers: [
                    { label: 'Abertas', value: 'O' },
                    { label: 'Em Andamento', value: 'A' },
                    { label: 'Concluída', value: 'C' }
                ],
                selected: 'O'
            },
            selectedDemand: {},
            selectedDemandId: '',
            title: '',
            showColumns: Model.visibleFields,
            columnNames: Model.fieldNames,
            selectedItems: [],
            currentSort: 'id',
            currentSortOrder: 'asc',
            pagination: {
                perPage: parseInt(10),
                currentPage: 1,
                total: 0
            },
            editing: {
                demand_id: 0,
                current_week: 0,
                first_week: 0,
                second_week: 0,
                current_week_interval: 0,
                first_week_interval: 0,
                second_week_interval: 0,
                current_week_year: 0,
                first_week_year: 0,
                second_week_year: 0
            },
            filterLoading: true
        }
    },

    methods: {
        ...mapActions('demands', {
            readListDemands: 'readListDemands',
            updateIntervalDemand: 'updateIntervalDemand',
            updateDateNapDemand: 'updateDateNapDemand',
            create: 'create'
        }),

        EditModal() {
            this.Edit = true
        },

        async closeEdit() {
            this.Edit = false
            await this.fetchDemands()
        },

        handleModalTree(value, item) {
            if (value == 'close') {
                this.treeModal = false
                return
            } else if (value == 'open') {
                this.treeModal = true
                return
            } else if (value == 'filterNodeName') {
                this.tree.text = item
                return
            }
            this.node = item.id
        },

        onSelectDemand(items) {
            this.selectedItems = items
        },

        async submitDateNapDemand(items) {
            this.loading = true

            await this.updateDateNapDemand(items)
            this.loading = false
            this.ModalType = 'success'

            await this.fetchDemands()
        },

        OpenSleepModal() {
            this.DemandaModal = true
            this.ModalType = 'sleep'
        },

        resetModal() {
            this.DemandaModal = false
            this.ModalType = ''
        },

        async handleReset() {
            this.curve.selected = null
            this.branch.text = ''
            this.error = ''
            this.type_branch.selected = null
            this.task_status.selected = 'O'
            this.start_date = null
            this.end_date = null
            this.tree.text = 'Todos os itens'
            this.node = null
            await this.handleSearch()
        },

        async handleSearch() {
            this.filterLoading = true
            await this.readListDemands({
                page: this.pagination.currentPage,
                node: this.node,
                curve: this.curve.selected,
                branch: this.branch.text,
                type_branch: this.type_branch.selected,
                task_status: this.task_status.selected,
                start_date: this.start_date
            })
            this.customSort(this.demandsListPage.results)
            this.filterLoading = false
        },

        startDate(date) {
            this.start_date = date
        },

        endDate(date) {
            if (this.start_date > date) {
                this.error = 'Data final não pode ser menor que inicial'
            } else {
                this.end_date = date
                this.error = ''
            }
        },

        async fetchDemands() {
            this.filterLoading = true
            await this.readListDemands({
                page: this.pagination.currentPage,
                node: this.node,
                curve: this.curve.selected,
                branch: this.branch.text,
                type_branch: this.type_branch.selected,
                task_status: this.task_status.selected,
                start_date: this.start_date
            })
            this.customSort(this.demandsListPage.results)
            this.filterLoading = false
        },

        customSort(value) {
            return value.sort((a, b) => {
                const sortBy = this.currentSort
                try {
                    if (
                        typeof a[sortBy] === 'number' ||
                        typeof b[sortBy] === 'number' ||
                        typeof a[sortBy] === 'boolean' ||
                        typeof b[sortBy] === 'boolean'
                    ) {
                        if (this.currentSortOrder === 'desc')
                            return a[sortBy] - b[sortBy]
                        return b[sortBy] - a[sortBy]
                    }
                    if (
                        (a[sortBy] &&
                            typeof a[sortBy] === 'string' &&
                            a[sortBy].includes('/')) ||
                        (b[sortBy] &&
                            typeof b[sortBy] === 'string' &&
                            b[sortBy].includes('/'))
                    ) {
                        const dateA =
                            a[sortBy] &&
                            typeof a[sortBy] === 'string' &&
                            a[sortBy].includes('/')
                                ? new Date(
                                      a[sortBy].split('/')[2],
                                      a[sortBy].split('/')[1],
                                      a[sortBy].split('/')[0]
                                  )
                                : 0
                        const dateB =
                            b[sortBy] &&
                            typeof b[sortBy] === 'string' &&
                            b[sortBy].includes('/')
                                ? new Date(
                                      b[sortBy].split('/')[2],
                                      b[sortBy].split('/')[1],
                                      b[sortBy].split('/')[0]
                                  )
                                : 0
                        if (this.currentSortOrder === 'desc')
                            return dateA - dateB
                        return dateB - dateA
                    }
                    if (this.currentSortOrder === 'desc')
                        return String(a[sortBy] || '').localeCompare(
                            String(b[sortBy] || '')
                        )
                    return String(b[sortBy] || '').localeCompare(
                        String(a[sortBy] || '')
                    )
                } catch (e) {
                    return 0
                }
            })
        },

        handleEditFieldTable(item) {
            if (this.editing.demand_id === 0) {
                const indexCurrentWeek = item.demands
                    .map(e => e.interval)
                    .indexOf('current_week')
                const indexFirstWeek = item.demands
                    .map(e => e.interval)
                    .indexOf('first_week')
                const indexSecondWeek = item.demands
                    .map(e => e.interval)
                    .indexOf('second_week')
                this.editing = {
                    demand_id: item.id,
                    current_week: item.demands[indexCurrentWeek].quantity,
                    first_week: item.demands[indexFirstWeek].quantity,
                    second_week: item.demands[indexSecondWeek].quantity,
                    current_week_interval: item.demands[indexCurrentWeek].week,
                    first_week_interval: item.demands[indexFirstWeek].week,
                    second_week_interval: item.demands[indexSecondWeek].week,
                    current_week_year: item.demands[indexCurrentWeek].year,
                    first_week_year: item.demands[indexFirstWeek].year,
                    second_week_year: item.demands[indexSecondWeek].year
                }
            }
        },

        handleCancelEditing() {
            this.editing = {
                demand_id: 0,
                current_week: 0,
                first_week: 0,
                second_week: 0,
                current_week_interval: 0,
                first_week_interval: 0,
                second_week_interval: 0,
                current_week_year: 0,
                first_week_year: 0,
                second_week_year: 0
            }
        },

        async handleSaveEditing() {
            const quantity = [
                {
                    interval: Number(this.editing.current_week_interval),
                    quantity: Number(this.editing.current_week),
                    year: Number(this.editing.current_week_year)
                },
                {
                    interval: Number(this.editing.first_week_interval),
                    quantity: Number(this.editing.first_week),
                    year: Number(this.editing.first_week_year)
                },
                {
                    interval: Number(this.editing.second_week_interval),
                    quantity: Number(this.editing.second_week),
                    year: Number(this.editing.second_week_year)
                }
            ]

            await this.updateIntervalDemand({
                id: this.editing.demand_id,
                quantity
            })

            this.editing = {
                demand_id: 0,
                current_week: 0,
                first_week: 0,
                second_week: 0,
                current_week_interval: 0,
                first_week_interval: 0,
                second_week_interval: 0,
                current_week_year: 0,
                first_week_year: 0,
                second_week_year: 0
            }

            await this.fetchDemands()
        },

        checkParams() {
            const startDate = this.$route.params.startDate
            const endDate = this.$route.params.endDate
            const status = this.$route.params.status
            if (startDate) {
                const [year, month, day] = new Date(startDate)
                    .toISOString()
                    .substr(0, 10)
                    .split('-')
                this.start_date = `${year}-${month.padStart(
                    2,
                    '0'
                )}-${day.padStart(2, '0')}`
            }
            if (endDate) {
                const [year, month, day] = new Date(endDate)
                    .toISOString()
                    .substr(0, 10)
                    .split('-')
                this.end_date = `${year}-${month.padStart(
                    2,
                    '0'
                )}-${day.padStart(2, '0')}`
            }
            if (status) {
                this.task_status.selected = status
            }
        }
    },

    watch: {
        pagination: {
            handler: function(val) {
                this.filterLoading = true
                this.readListDemands({ page: val.currentPage })
                this.filterLoading = false
            },
            deep: true
        },
        filterLoading: {
            handler: function(val) {
                this.selectedItems = []
                this.editing = {
                    demand_id: 0,
                    current_week: 0,
                    first_week: 0,
                    second_week: 0,
                    current_week_interval: 0,
                    first_week_interval: 0,
                    second_week_interval: 0,
                    current_week_year: 0,
                    first_week_year: 0,
                    second_week_year: 0
                }
            },
            deep: true
        }
    }
}
</script>

<style scoped>
.outlabel {
    font-family: Inter;
    font-size: 14px;
    font-weight: 500;
}
</style>
